/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import { loadReportingFrameworksByPrimaryConnections } from '../../actions/reportingFrameworks';
import { Loader } from '@g17eco/atoms/loader';
import { useAppDispatch, useAppSelector } from '../../reducers';
import SDGAP from './SDGAP';
import { sdgGapRoutes } from './routes';

export const PrimaryConnections = () => {

  const dispatch = useAppDispatch();
  const frameworks = useAppSelector((state) => state.reportingFrameworks);

  React.useEffect(() => {
    dispatch(loadReportingFrameworksByPrimaryConnections());
  }, [dispatch]);

  if (!frameworks.loaded || frameworks.reportType !== 'primary-connections') {
    return <Loader />
  }

  return <SDGAP
    route={sdgGapRoutes.SDGAP_PRIMARY_CONNECTIONS}
  />;
}
